var _style, _rect, _defs, _defs2, _path, _path2, _path3, _path4, _defs3, _defs4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeta2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45.4 25",
    style: {
      enableBackground: "new 0 0 45.4 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{enable-background:new    ;}\n\t.st2{clip-path:url(#SVGID_00000072959797710318277140000012415779897155942066_);}\n\t.st3{clip-path:url(#SVGID_00000072985756760107406930000014289497043462563212_);}\n\t.st4{fill:#55BBB1;}\n\t.st5{clip-path:url(#SVGID_00000103966744425985430800000004907248931714698413_);}\n\t.st6{clip-path:url(#SVGID_00000099636883240749843710000016910140141379890090_);fill:none;stroke:#55BBB1;stroke-miterlimit:5;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 61,
    height: 35,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAkCAYAAADRjIm5AAAACXBIWXMAAAsSAAALEgHS3X78AAAC XUlEQVRogeVaW1LDMAx0AnfigztxGO7EB4ci4acOYrOSVk7aaac740nqyLZWL+fRqQ3g4/trGhl3 bXy+va+qbInAvRJGKAaQiDwKYURkgJRQgfStjSOFtUc+VDYhnRE9yxBq3rpyjLyrXEAa+1W5UWTE 8TqVR/JUOZH0RPpujVU432DJvxYWQaLMCHh+FhiR1azFzsNIUYl7pFVjMMh7LszFQpuRDsnviAtV 3JKcWkxemUeBJeARkzzdMQsySNSe9zabo20vlzabI7bJGYvzz7AO6uDpucE6tZLj1hBR2y1I+tGD 3joIxauSxys5jvmrGCBTrpLnfV2v0KmyrbW6xyMDzI17PFIAr2ERi4ra1FpbyJynVHXmOeZdlnPe PKgYnntrY1FbiAwjTY0wkuOoWDXUvWqM82I/yrNokKv6EeJ9IfwdbWtRLkZRgn1R1EhQtjO2cKSU dz2Sz+Qqe76EKvGoGqf3yslcazBvtfqnOBrqXuWNQm9tezLRuKiyZ/0ujhC3eVZZmBG317Kxdg5l DEVGnBUd5qml/aWNHcPu1FiIW0Tr2T6vMdkdqh7H/dZO2vfVKDQz0tgX7QyjUdNa04lHhJlsVIWr RZCNR/Lo8TT9RnJcIZ0ZKiKvFjOPvITddkZezHkFxbbFaT+X5l1fCnNFY7xi5xpi1OPWq/a3dxcW KeIpp6RLdvyHkXduHjkWHerto7p1qTIS+Y6Kxz1S7KHjlojIu3DD6crv1c80TlQ4N0jv1TsOfElR HyquaYANpS8pHU/57azjKb+WWjyKAU77Po64VwNU/hHxtPgF0fkhWZT2Po4AAAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 -8.0921 -4.9)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -8.1,
    y: -4.9,
    className: "st0",
    width: 61,
    height: 35
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1.9,
    y: 5.1,
    width: 41,
    height: 15
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137112398692565816820000004967752726396608156_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137112398692565816820000004967752726396608156_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000047751844563974418760000011144710646258614958_",
    x: -5.1,
    y: -4.9,
    width: 56,
    height: 35
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145748248288198272700000011756820427474875027_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047751844563974418760000011144710646258614958_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145748248288198272700000011756820427474875027_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M13.7,12.5c0.6,0.3,1,0.9,1,1.6c0,0.6-0.2,1.1-0.7,1.5c-0.4,0.3-1,0.5-1.7,0.5H9.6c0,0-0.1,0-0.1,0 s0-0.1,0-0.1V9.2c0,0,0-0.1,0-0.1s0.1,0,0.1,0h2.5c1.6,0,2.4,0.6,2.4,1.9C14.5,11.7,14.2,12.2,13.7,12.5 C13.6,12.5,13.6,12.5,13.7,12.5z M10.9,10.4v1.6c0,0,0,0,0,0h1.2c0.3,0,0.6-0.1,0.7-0.2c0.2-0.1,0.3-0.3,0.3-0.6 c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.4-0.2-0.7-0.2L10.9,10.4C10.9,10.3,10.9,10.3,10.9,10.4z M12.9,14.6c0.2-0.2,0.3-0.4,0.3-0.6 s-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.2-0.7-0.2H11c0,0,0,0,0,0.1v1.7c0,0,0,0,0,0h1.2C12.5,14.9,12.8,14.8,12.9,14.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.2,10.3C22.2,10.3,22.1,10.3,22.2,10.3l-3.4,0c0,0,0,0,0,0v1.5c0,0,0,0.1,0,0.1H21c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1v1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-2.2c0,0,0,0,0,0v1.6c0,0,0,0,0,0h3.3c0,0,0.1,0,0.1,0s0,0.1,0,0.1v1 c0,0,0,0.1,0,0.1s-0.1,0-0.1,0h-4.6c0,0-0.1,0-0.1,0s0-0.1,0-0.1V9.2c0,0,0-0.1,0-0.1s0.1,0,0.1,0h4.6c0,0,0.1,0,0.1,0 s0,0.1,0,0.1L22.2,10.3C22.2,10.2,22.2,10.3,22.2,10.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.8,9.1C29.8,9.2,29.8,9.2,29.8,9.1l0,1.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0h-1.8c0,0,0,0,0,0V16 c0,0,0,0.1,0,0.1s-0.1,0-0.1,0h-1.2c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-5.6c0,0,0,0,0,0h-1.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v-1 c0,0,0-0.1,0-0.1s0.1,0,0.1,0L29.8,9.1C29.7,9.1,29.7,9.1,29.8,9.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36,16l-0.3-1c0,0,0,0,0,0h-2.5c0,0,0,0-0.1,0l-0.3,1c0,0.1-0.1,0.1-0.1,0.1h-1.3c0,0-0.1,0-0.1,0 s0-0.1,0-0.1l2.2-6.8c0-0.1,0.1-0.1,0.1-0.1h1.6c0.1,0,0.1,0,0.1,0.1l2.2,6.8c0,0,0,0,0,0c0,0.1,0,0.1-0.1,0.1h-1.3 C36.1,16.1,36.1,16.1,36,16z M33.6,13.9h1.8c0,0,0.1,0,0-0.1l-0.9-3c0,0,0,0,0,0c0,0,0,0,0,0L33.6,13.9 C33.5,13.9,33.5,13.9,33.6,13.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137112398692565816820000004967752726396608156_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000082367901244371407280000014274248435413919649_",
    d: "M7.9,5.1h30c1.7,0,3,1.3,3,3v9c0,1.7-1.3,3-3,3h-30 c-1.7,0-3-1.3-3-3v-9C4.9,6.4,6.3,5.1,7.9,5.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080206143610418482150000009871951726884726962_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082367901244371407280000014274248435413919649_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080206143610418482150000009871951726884726962_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000138551482374125908810000004914875353467884197_",
    x: -5.1,
    y: -4.9,
    width: 56,
    height: 35
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018950278997844099640000015807420603272585641_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000138551482374125908810000004914875353467884197_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000018950278997844099640000015807420603272585641_)",
      fill: "none",
      stroke: "#55BBB1",
      strokeMiterlimit: 5
    },
    d: " M7.9,5.1h30c1.7,0,3,1.3,3,3v9c0,1.7-1.3,3-3,3h-30c-1.7,0-3-1.3-3-3v-9C4.9,6.4,6.3,5.1,7.9,5.1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta2);
export default __webpack_public_path__ + "static/media/beta2.134e12a66744f574f5bfdad19b38327b.svg";
export { ForwardRef as ReactComponent };